module.exports = __webpack_public_path__ + "img/label_leed_platinum2.69793e79.png";